import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledFarmNotPublicBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  margin: 16px 50px 0 50px;
  padding: 12px 16px;

  background-color: ${({ theme }) => theme.warningBannerBg};
  border: 1px solid ${({ theme }) => theme.warningBannerBorder};
  border-left-width: 4px;
  border-radius: 6px;

  color: ${({ theme }) => theme.warningBannerText};
  font-size: 14px;
  line-height: 1.4;

  .anticon {
    color: ${({ theme }) => theme.warningBannerBorder};
    font-size: 18px;
    flex-shrink: 0;
  }

  a {
    color: inherit;
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    margin: 16px 16px 0 16px;
  }
`;
